<template>
  <modal-provider
    :fullscreen-breakpoint="768"
    name="shops-filter-modal"
    :width="900"
    @before-open="beforeOpen"
    @closed="onClosed"
  >
    <ShopsFilter modal @approved-filters="hideFilters" filter-by-services />
  </modal-provider>
</template>

<script>
import { mapActions } from 'vuex'
import ShopsFilter from './ShopsFilter'

export default {
  name: 'ShopsFilterModal',
  components: { ShopsFilter },
  methods: {
    ...mapActions(['SET_IS_SHOW_FILTERS_MODAL_ACTION']),
    hideFilters () {
      this.$modal.hide('shops-filter-modal')
    },
    beforeOpen () {
      this.SET_IS_SHOW_FILTERS_MODAL_ACTION(true)
    },
    onClosed () {
      this.SET_IS_SHOW_FILTERS_MODAL_ACTION(false)
    }
  }
}
</script>

<style scoped lang="sass">
::v-deep
  .modal-body
    padding: 0
  .shops-filter__city-wrap
    padding-top: 0
</style>
